import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table12 = ({ damaneErtebatiScore, setDamaneErtebatiScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)


  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.gDamaneErtebati;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },

      ]


      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setDamaneErtebatiScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "gDamaneErtebati": selectedItem }))
    }
  }, [reload])



  return (
    <div>

      <Row type={1}>
        <Column >سطح یک</Column>
        <Column >سطح دو</Column>
        <Column >سطح سه</Column>
        <Column >سطح چهار</Column>
        <Column >سطح پنج</Column>

      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          ارتباط موثر با همکاران و
          اراباب رجوع
        </Column>
        <Column paddingY={30}>
          برای انجام وظایف جاری
          با خارج از سازمان جهت
          مذاکره، خرید و... نیز در
          ارتباط است.
        </Column>
        <Column paddingY={30}>
          عالوه بر افراد و
          سازمانها با روسای
          ادارت و موسسات
          خصوصی و دولتی به
          منظور تحقق اهداف
          سازمان در تعامل
          است.
        </Column>
        <Column paddingY={30}>
          عالوه بر موارد
          سطوح قبلی با مدیران
          عامل، و مقامات
          باالتر جهت نیل به
          هدفهای اساسی
          سازمان در تعامل
          است.
        </Column>
        <Column paddingY={30}>
          عالوه بر موارد قبلی در
          سطوح ملی و بین المللی
          نیز با مدیران ارشد و
          روسای سازمانها ، نهادها
          ، وزارتخانه نیز در تعامل
          است.
        </Column>
      </Row>
      <Row>
        <Column isActive={damaneErtebatiScore == 16}>16 </Column>
        <Column isActive={damaneErtebatiScore == 24}>24 </Column>
        <Column isActive={damaneErtebatiScore == 32}> 32</Column>
        <Column isActive={damaneErtebatiScore == 40}> 40</Column>  <Column isActive={damaneErtebatiScore == 8}> 8</Column>

      </Row>
    </div>
  );
};

export default Table12;
